import { render, staticRenderFns } from "./OtherWeiYuanHui.vue?vue&type=template&id=3fdc8b1e&scoped=true&"
import script from "./OtherWeiYuanHui.vue?vue&type=script&lang=js&"
export * from "./OtherWeiYuanHui.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fdc8b1e",
  null
  
)

export default component.exports